import { createContext } from 'react';

/**
 * Provides a flag that a form is in read-only mode (e.g., due to lack of permissions)
 */
export const ReadonlyFormContext = createContext<boolean>(false);
